import { ddds } from "../assets/js/ddds";

const mask = {
  methods: {
    formatCellphone(s) {
      this[s] = this[s].replace(/\D/g, "");
      const s1 = this[s].substring(0, 2);
      const s2 = this[s].substring(2, 7);
      const s3 = this[s].substring(7, 11);
      const len = this[s].length;
      if (len > 7) this[s] = `(${s1}) ${s2}-${s3}`;
      else if (len > 2) this[s] = `(${s1}) ${s2}`;
      else if (len > 0) this[s] = `(${s1}`;
    },

    formatPersonalId(fieldName) {
      let value = this[fieldName];
      let result = "";

      if (!value) return value; // If value is falsy, return it as it is

      value = value.replace(/\D/g, "");

      const len = value.length;
      if (len > 9)
        result = `${value.substring(0, 3)}.${value.substring(
          3,
          6
        )}.${value.substring(6, 9)}-${value.substring(9, 11)}`;
      else if (len > 6)
        result = `${value.substring(0, 3)}.${value.substring(
          3,
          6
        )}.${value.substring(6, 9)}`;
      else if (len > 3)
        result = `${value.substring(0, 3)}.${value.substring(3, 6)}`;
      else result = value; // If less than 3 characters, no formatting needed

      return result;
    },

    formatBusinessId(fieldName) {
      let value = this[fieldName];
      let result = "";

      if (!value && fieldName) value = fieldName;

      if (!value) return fieldName;

      value = value.replace(/[^A-Z0-9]/gi, "").toUpperCase();
      if (value.length > 11 || /[A-Z]/.test(value)) {
        const s1 = value.substring(0, 2);
        const s2 = value.substring(2, 5);
        const s3 = value.substring(5, 8);
        const s4 = value.substring(8, 12);
        const s5 = value.substring(12, 14);
        const len = value.length;
        if (len > 12) result = `${s1}.${s2}.${s3}/${s4}-${s5}`;
        else if (len > 8) result = `${s1}.${s2}.${s3}/${s4}`;
        else if (len > 5) result = `${s1}.${s2}.${s3}`;
        else if (len > 2) result = `${s1}.${s2}`;

        if (this[fieldName]) this[fieldName] = result;
      }
      return result;
    },

    formatZipcode(s) {
      this[s] = this[s].replace(/\D/g, "");
      const s1 = this[s].substring(0, 2);
      const s2 = this[s].substring(2, 5);
      const s3 = this[s].substring(5, 8);
      const len = this[s].length;
      if (len > 5) this[s] = `${s1}.${s2}-${s3}`;
      else if (len > 2) this[s] = `${s1}.${s2}`;
    },

    formatOnlyDigits(s) {
      this[s] = this[s].replace(/\D/g, "");
    },

    formatMoney(value) {
      let val = (Math.round(value) / 100).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },

    formatMoneyToCents(value) {
      return Number(String(value.toFixed(2)).replace(/[^0-9]+/g, ""));
    },

    formatPersonalIdOrEmail(inputname) {
      if (event.key !== "Backspace") {
        if (/^[0-9]{3}\.[0-9]{3}\.[0-9]{3}\-[0-9]{2}/.test(this[inputname])) {
          this[inputname] = `${this[inputname].substring(0, 14)}`;
        } else if (/^[0-9]{3}\.[0-9]{3}\.[0-9]{4}/.test(this[inputname])) {
          this[inputname] = `${this[inputname].substring(0, 11)}-${this[
            inputname
          ].substring(11)}`;
        } else if (/^[0-9]{3}\.[0-9]{4}/.test(this[inputname])) {
          this[inputname] = `${this[inputname].substring(0, 7)}.${this[
            inputname
          ].substring(7)}`;
        } else if (/^[0-9]{4}/.test(this[inputname])) {
          this[inputname] = `${this[inputname].substring(0, 3)}.${this[
            inputname
          ].substring(3)}`;
        }
      }
    },

    cellphoneWithCountryCallingCode(p) {
      if (!p) return "";
      const countryCallingCode = p.countryCallingCode || "55";
      return p.cellphone.substring(0, 3) === "+55"
        ? p.cellphone
        : `${countryCallingCode} ${p.cellphone}`;
    },

    isEmailValid(email) {
      if (!email) return false;

      if (email.length > 254) return false;

      const emailRegex = /^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
      const valid = emailRegex.test(email);
      if (!valid) return false;

      // Further checking of some things regex can't handle
      const parts = email.split("@");
      if (parts[0].length > 64) return false;

      const domainParts = parts[1].split(".");
      if (
        domainParts.some(function(part) {
          return part.length > 63;
        })
      )
        return false;

      return true;
    },

    isCellphoneValid(cellphone) {
      cellphone = cellphone.replace(/\D/g, "");

      if (!ddds.includes(Number(cellphone.substring(0, 2)))) return false;

      if (cellphone.length !== 10 && cellphone.length !== 11) return false;

      return true;
    },

    isPersonalIdValid(personalId) {
      personalId = personalId.replace(/\D/g, "");
      if (personalId.length !== 11) return false;

      let soma = 0;
      let resto;

      if (
        [
          "00000000000",
          "11111111111",
          "22222222222",
          "33333333333",
          "44444444444",
          "55555555555",
          "66666666666",
          "77777777777",
          "88888888888",
          "99999999999"
        ].includes(personalId)
      )
        return false;

      for (let i = 1; i <= 9; i++)
        soma += parseInt(personalId.substring(i - 1, i)) * (11 - i);
      resto = (soma * 10) % 11;

      if (resto == 10 || resto == 11) resto = 0;
      if (resto != parseInt(personalId.substring(9, 10))) return false;

      soma = 0;
      for (let i = 1; i <= 10; i++)
        soma += parseInt(personalId.substring(i - 1, i)) * (12 - i);
      resto = (soma * 10) % 11;

      if (resto == 10 || resto == 11) resto = 0;
      if (resto != parseInt(personalId.substring(10, 11))) return false;

      return true;
    },

    getCurrencySymbolBasedOnCurrency(currency) {
      return currency === "EUR"
        ? "€"
        : currency === "USD"
        ? "$"
        : currency === "AED"
        ? "AED" // O símbolo é "د.إ", mas optamos por usar AED
        : "R$";
    }
  },

  filters: {
    cellphoneWithCountryCode(v) {
      return `${v.substring(0, 3)} (${v.substring(3, 5)}) ${v.substring(5)}`;
    },
    cellphoneWithoutCountryCode(v) {
      return `(${v.substring(3, 5)}) ${v.substring(5)}`;
    }
  }
};

export { mask };
